import { add, differenceInCalendarDays, startOfDay } from 'date-fns';
import * as libCon from '../community-hats-js-library/Constants.js';
import { formatInStudyLocationToCustom } from '../community-hats-js-library/utils/dateFunctions.js';
import { getCurrentI18n } from '../hooks/LanguageHooks';

export const dateFormatter = (date) => {
  return formatInStudyLocationToCustom(date, 'dd/MMM');
};

export const getTicks = (startDate, endDate, num) => {
  const start = startOfDay(startDate);
  const end = startOfDay(endDate);

  const diffDays = Math.round(differenceInCalendarDays(end, start));
  const velocity = Math.round(diffDays / (num - 1)); // Ensure complete days only

  const ticks = [start.getTime()];

  for (let i = 1; i < num - 1; i++) {
    const tick = add(start, { days: i * velocity });
    ticks.push(tick.getTime());
  }

  ticks.push(end.getTime());

  return ticks;
};

export const getColorByLocation = (location, transparent = false) => {
  switch (location) {
    case libCon.ATF_AHMEDABAD:
      return transparent !== true ? 'var(--color-ahmedabad)' : 'var(--color-ahmedabad-t)';
    case libCon.ATF_FIROZABAD:
      return transparent !== true ? 'var(--color-firozabad)' : 'var(--color-firozabad-t)';
    case libCon.ATF_ANAND:
      return transparent !== true ? 'var(--color-anand)' : 'var(--color-anand-t)';
    case libCon.ATF_ALL_LOCATIONS:
      return transparent !== true ? 'var(--color-all-locations)' : 'var(--color-all-locations-t)';
    default:
      return '#FFADAD';
  }
};

// Period labels for chart display, as catalogue keys.
const PERIOD_LABELS = {
  [libCon.MORNING]: 'morning',
  [libCon.AFTERNOON]: 'afternoon',
  [libCon.EVENING]: 'evening',
  [libCon.NIGHT]: 'night',
  [libCon.ALL]: 'all',
};

export const getColorForPeriod = (location, period) => {
  // Base colors for locations (Hue and Saturation)
  const baseColors = {
    [libCon.ATF_AHMEDABAD]: { h: 25, s: 90 }, // Orange
    [libCon.ATF_FIROZABAD]: { h: 0, s: 85 }, // Red
    [libCon.ATF_ANAND]: { h: 120, s: 75 }, // Green
  };

  // Period lightness variations (from light to dark)
  const periodLightness = {
    [libCon.MORNING]: 70, // Light (morning)
    [libCon.AFTERNOON]: 55, // Medium (afternoon)
    [libCon.EVENING]: 40, // Dark (evening)
    [libCon.NIGHT]: 25, // Very dark (night)
    [libCon.ALL]: 50, // Base (All)
  };

  const base = baseColors[location] || { h: 200, s: 50 };
  const l = periodLightness[period] || 50;

  return `hsl(${base.h}, ${base.s}%, ${l}%)`;
};

export const getPeriodLabel = (period, i18n = null) => {
  const key = PERIOD_LABELS[period];
  if (key === undefined) return period;

  return i18n === null ? getCurrentI18n().t(key) : i18n.t(key);
};
